import React, { useState, useEffect } from "react";

// Immporting Component
import OverallStatus from "./AnalyticsTab/OverallStatus";
import MyDashboard from "./AnalyticsTab/MyDashboard";
import CollaboratorPerformanceTab from "./AnalyticsTab/CollaboratorPerformanceTab";
import CustomerAnalysisTab from "./AnalyticsTab/CustomerAnalysisTab";
import UserPerformanceTab from "./AnalyticsTab/UserPerformanceTab";

function AnalyticsIndex() {
  const [step, setStep] = useState(1);

  return (
    <div className="sm:mx-6 lg:mx-8">
      <div className={`sm:block sm:pt-1`}>
        <ul
          className="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="text-left">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                step === 1 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              id="My_Dashboard"
              onClick={() => setStep(1)}
            >
              My Dashboard
            </a>
          </li>
          <li className="text-left">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                step === 2 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              id="Overall_Status"
              onClick={() => setStep(2)}
            >
              Overall Status
            </a>
          </li>
          <li className="text-left">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                step === 3 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              id="Collaborator_Performance"
              onClick={() => setStep(3)}
            >
              Collaborator Performance
            </a>
          </li>
          <li className="text-left">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                step === 4 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              id="Customer_Analytics"
              onClick={() => setStep(4)}
            >
              Customer Analytics
            </a>
          </li>
          <li className="text-left">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                step === 5 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              id="User_Performance"
              onClick={() => setStep(5)}
            >
              User Performance
            </a>
          </li>
        </ul>
      </div>

      {step === 1 && <MyDashboard />}
      {step === 2 && <OverallStatus />}
      {step === 3 && <CollaboratorPerformanceTab />}
      {step === 4 && <CustomerAnalysisTab />}
      {step === 5 && <UserPerformanceTab />}
    </div>
  );
}

AnalyticsIndex.auth = { path: "/analytics", role: "super-admin admin" };

export default AnalyticsIndex;
